import ShippingPaymentsContainer from "./ShippingPaymentsContainer";

export default ShippingPaymentsContainer;
